import { defineToolkit } from '@assistant-ui/react';
import { AI_WRITE_TOOL_NAMES } from '@restaurant/api-contracts';
import { ApprovalCard, MenuItemsCard, ReservationListCard, RevenueCard } from './ToolCards';

export const assistantToolkit = defineToolkit({
  list_reservations: { type: 'backend', render: ReservationListCard },
  get_revenue: { type: 'backend', render: RevenueCard },
  get_item_availability: { type: 'backend', render: MenuItemsCard },
  ...Object.fromEntries(
    AI_WRITE_TOOL_NAMES.map((name) => [name, { type: 'backend' as const, render: ApprovalCard }]),
  ),
});
